import { Box, Typography } from "@mui/material";
import Dron1 from "../images/h1.png";
import Dron2 from "../images/h2.png";
import Dron3 from "../images/h3.png";
const Section5 = () => {
	return (
		<Box sx={{ height: "80vh", position: "relative" }} className="droneProduct">
			<Box sx={{
				display: "flex", "&>div": {

					width: "25%", height: 450,
				},
				"& .imgWrap": {
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					flexDirection: "column",
					height: "100%",

					"& img": {
						width: "100%", display: "block", maxHeight: "100%,"
					},
				},
				"& h3": {
					fontSize: "2rem",
					textAlign: "center",
					fontWeight: 700,
					textTransform: "uppercase",
				}
			}
			} >
				<Box>
					<Typography component="h3" variant="h3">FPV DRONE</Typography>

					<Box className="imgWrap">
						<img src={Dron2} alt="no-drone1" />

					</Box>

				</Box>
				<Box>
					<Typography component="h3" variant="h3">SURVEILLANCE</Typography>

				</Box>
				<Box>
					<Typography component="h3" variant="h3">LOGISTIC</Typography>

					<Box className="imgWrap">
						<img src={Dron1} alt="no-drone2" />

					</Box>
				</Box>
				<Box>
					<Typography component="h3" variant="h3">AGRICULTURE</Typography>

					<Box className="imgWrap">
						<img src={Dron3} alt="no-drone3" />

					</Box>

				</Box>
			</Box>
			<Typography variant="h3" component="h3" sx={{
				position: "absolute",
				right: 0,
				color: "#FFF",
				zIndex: 7,
				bottom: 0,
				fontSize: "8rem",
				opacity: 0.1,
				linHeight: 1,
				fontWeight: 700,

			}}>
				DRONE
				<Typography sx={{ fontSize: "inherit", lineHeight: 1, fontWeight: 700 }} component="p">TYPES</Typography> </Typography>
		</Box>
	)
}

export default Section5;